var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:facebook",
    clipPath: "url(#clip0_572_24971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5 12.4462C24.5 5.81879 19.1274 0.446167 12.5 0.446167C5.87262 0.446167 0.5 5.8187 0.5 12.4462C0.5 18.4357 4.88825 23.4002 10.625 24.3004V15.9149H7.57812V12.4462H10.625V9.80242C10.625 6.79492 12.4166 5.13367 15.1575 5.13367C16.4705 5.13367 17.8438 5.36804 17.8438 5.36804V8.32117H16.3306C14.8398 8.32117 14.375 9.2462 14.375 10.1952V12.4462H17.7031L17.1711 15.9149H14.375V24.3004C20.1117 23.4002 24.5 18.4358 24.5 12.4462Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.1711 15.9149L17.7031 12.4462H14.375V10.1952C14.375 9.2461 14.8399 8.32117 16.3306 8.32117H17.8438V5.36804C17.8438 5.36804 16.4705 5.13367 15.1575 5.13367C12.4166 5.13367 10.625 6.79492 10.625 9.80242V12.4462H7.57812V15.9149H10.625V24.3004C11.2453 24.3976 11.8722 24.4463 12.5 24.4462C13.1278 24.4464 13.7547 24.3976 14.375 24.3004V15.9149H17.1711Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_572_24971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.446167)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d509925d692e922d87e09ecc129356ba.svg";
export { ForwardRef as ReactComponent };